import { render } from "./UpdateEmailSettingPanel.vue?vue&type=template&id=56fc1e24&scoped=true"
import script from "./UpdateEmailSettingPanel.vue?vue&type=script&lang=js"
export * from "./UpdateEmailSettingPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fc1e24"]])

export default __exports__